import { createContext, useContext } from 'react';

const AvatarGroupContext = createContext(undefined);
function useAvatarGroupContext() {
    return useContext(AvatarGroupContext);
}

export { AvatarGroupContext, useAvatarGroupContext };
//# sourceMappingURL=avatar-group.context.js.map
